import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    reduxForm,
    Field
} from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndTextarea from '../common/form/labelAndTextarea';

import {
    setModoTela
} from './clienteAreaActions';

let ClienteAreaForm = props => {

    const readOnly = props.excluir ? 'readOnly' : '';

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>

                    <Row>
                        <Field
                            name='nome'
                            component={LabelAndInput}
                            label='Área *'
                            placeholder='Informe'
                            cols='12 6 6 6'
                            readOnly={readOnly}
                        />
                    </Row>

                    <Row>
                        <Field
                            name='area_propria'
                            component={LabelAndInputNumber}
                            label='Área Própria (ha)'
                            placeholder='Informe'
                            cols='12 3 3 3'
                            casas={2}
                            readOnly={readOnly}
                        />

                        <Field
                            name='area_arrendada'
                            component={LabelAndInputNumber}
                            label='Área Arrendada (ha)'
                            placeholder='Informe'
                            cols='12 3 3 3'
                            casas={2}
                            readOnly={readOnly}
                        />

                        <Field
                            name='observacao'
                            component={LabelAndTextarea}
                            label='Observação'
                            placeholder='Informe'
                            cols='12 12 12 12'
                            readOnly={readOnly}
                        />
                    </Row>
                </ContentCardBody>

                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() =>
                                    props.setModoTela('lista')
                                }
                            />
                        </Grid>

                        <Grid cols='6 6 4 3'>
                            {props.excluir &&
                                <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />}

                            {!props.excluir &&
                                <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

ClienteAreaForm = reduxForm({
    form: 'clienteAreaForm',
    destroyOnUnmount: false
})(ClienteAreaForm);

const mapStateToProps = state => ({
    registro: state.clienteArea.registro
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setModoTela
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClienteAreaForm);
